mutation ArchiveGroup($input: EmailSequenceTemplateGroupArchiveInput!) {
    emailSequenceTemplateGroupArchive(input: $input) {
        emailSequenceTemplateGroup {
            id
        }
    }
}
